import React,  { Component } from 'react';
import Highcharts from 'highcharts'
import Highcharts3d from 'highcharts/highcharts-3d'
import HighchartsReact from 'highcharts-react-official'
import {withStyles} from '@material-ui/core/styles';
import {BoxDrag} from './BoxDrag'
import {Dustbin} from './Dustbin'

const useStyles = (theme) => ({
  root: {
    display: 'flex',
    marginBottom: '1rem',
    marginTop: '1rem',
  },
  panel:{
    maxHeight: 380,
    overflow: 'auto',    
  }
})

class ChartTypeBars3D extends Component {

  constructor(props){
    super(props)    
    this.state = {
      isLoaded:false,
      options: {
        chart: {
          renderTo: 'container',
          type: 'bar',
          options3d: {
              enabled: true,
              alpha: 15,
              beta: 15,
              depth: 50,
              viewDistance: 25
          }
        },
        title: {
            text: ' '
        },       
        xAxis: {
            categories: [],
            crosshair: true
        },
        yAxis: {
            min: 0,
            title: {
                text: ' '
            }
        },
        tooltip: {
            headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
            pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
                '<td style="padding:0"><b>{point.y:.1f}</b></td></tr>',
            footerFormat: '</table>',
            shared: true,
            useHTML: true
        },
        plotOptions: {
            column: {
                pointPadding: 0.2,
                borderWidth: 0
            },
            bar: {
              dataLabels: {
                  enabled: true
              }
          },
        },
        series: []
      },
      managerOptions: [
        {
          allowedDropEffect: "any",
          title: "Categorias", 
          identify: "category",   
          data:[],    
        },
        {
          allowedDropEffect: "any",
          title: "Séries", 
          identify: "series",       
          data:[],        
        }
        
    
      ],      
    }         
  }

  componentDidUpdate(prevProps, prevState){    
    if(!prevState.isLoaded){
      this.loadingAll()      
    }    
  }

  loadingAll = () => {      
   
    if(!this.props.report) return    
    let newOption = {}

    
    // Object.assign(newOption, this.state.options)      
    Object.assign(newOption, this.props.report)      

    if(!newOption.series)
      newOption.series = []
  
    newOption.series.map(serie => serie.data = this.props.dataset.map(o=>o[serie.name]))   

    // let managerOption = {}
    // if(this.props.managerOptions && this.props.managerOptions.length > 10){
    //   managerOption = JSON.parse(this.props.managerOptions)
    // } else {
    //   managerOption = this.state.managerOptions
    // }
    
    // if(typeof managerOption === "string"){
    //   managerOption = JSON.parse(managerOption);
    // }

    this.setState({
      isLoaded: true,
      managerOptions: this.props.managerOptions,
      options: newOption,       
    })    
  }

  getPropertiesName = (data) => {          
    return this.props.dataset && this.props.dataset.length > 0
      ?Object.getOwnPropertyNames(this.props.dataset[0]).sort():[]         
  }

  handleSelected = (item, dropResult) => {     
  
    let newMp = [...this.state.managerOptions]
    const indexMp = newMp.map(m=>m.identify).indexOf(dropResult.name);
    //se já existe no array, não irá adicionar
    if(newMp[indexMp].data.find((d)=>d.name === item.name)){
      return
    }
    newMp[indexMp].data.push({
      name: item.name,
      color: '',
    }) 
    
    this.setState({managerOptions: newMp})    
    this.managerOption(item.name, dropResult.name)
  }

  eventOnDelete = (name, item,  identify) => {         
    // this.props.eventOnDelete
    let newMp = [...this.state.managerOptions]
    const indexMp = newMp.map(m=>m.identify).indexOf(identify)
    const newData = newMp[indexMp].data.filter(i => i.name !== name)
    newMp[indexMp].data = newData
    this.setState({managerOptions: newMp})
    this.managerOption(name, identify)
  }
  
  eventOnColor = (e, b, item, identify) => {     
    // this.props.eventOnColor    
    let newMp = [...this.state.managerOptions]
    const indexMp = newMp.map(m=>m.identify).indexOf(identify)
    const indexData = newMp[indexMp].data.map(d=>d.name).indexOf(item.name)
    newMp[indexMp].data[indexData] = {
      name: item.name,
      color: e.hex,
    }
    this.setState({managerOptions: newMp})
    this.managerOption(item.name, identify)
  }

  managerOption = (name, identify) => {

    let newOpition =  {}

    Object.assign(newOpition, this.state.options)
  
    const mpOption = this.state.managerOptions[this.state.managerOptions.map(m=>m.identify).indexOf(identify)]
      
    if(identify === "category"){   
      if(!newOpition.xAxis){
        newOpition.xAxis = {
          categories: [],
          title: {
              text: ""
          }
        }
      }         
      newOpition.xAxis.categories = this.props.dataset.map(o=>o[name]) 
    }
    if(identify === "series"){

      newOpition.series = []

      mpOption.data.map( d => 
        d.color?(newOpition.series.push({
            name: d.name,        
            color:d.color,
            data: this.props.dataset.map(o=>o[d.name]),
          })     
        ):(newOpition.series.push({
          name: d.name,        
          data: this.props.dataset.map(o=>o[d.name]),
        })      
        ) 
      )           
    }
    
    this.setState({options: newOpition})
    this.props.onEventOption(newOpition)
    this.props.onEnvetManagerOptions(this.state.managerOptions)  
  }

  render(){

    const { classes} = this.props;

    return(
      <div>
        <div className={classes.root}>
              
            <div className={classes.panel} >                   
              {this.getPropertiesName().map((item) =>               
                <BoxDrag key={item} name={item} eventOnChange={this.handleSelected} />
              )}          
            </div>      

            {this.state.managerOptions.map((item, index)=> 
              <div key={index} >             
                <Dustbin   
                    key={index}                
                    allowedDropEffect={item.allowedDropEffect} 
                    title={item.title} 
                    identify={item.identify}                  
                    data={item.data}     
                    eventOnDelete={this.eventOnDelete}             
                    eventOnColor={this.eventOnColor}             
                  />
              </div>)}
                    
        </div>  

           
        <HighchartsReact          
          highcharts={Highcharts3d(Highcharts)}
          options={this.state.options}
        />

      </div>
    )
  }
}

export default withStyles(useStyles)(ChartTypeBars3D)